// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chip-module_chip_3eb14"};